import React from 'react';
import { Switch, Route } from 'react-router-dom';
import FamilyList from './FamilyList';
import FamilyPage from './FamilyPage';
import FamilyRequestList from './FamilyRequestList';
import FamilyRequestPage from './FamilyRequestPage';

const Families = () => {
  return (
    <Switch>
      <Route path="/familias" exact component={FamilyList} />
      <Route path="/familias/:id/info" exact component={FamilyPage} />
      <Route path="/familias/solicitacoes" exact component={FamilyRequestList} />
      <Route path="/familias/solicitacoes/:id/info" exact component={FamilyRequestPage} />
    </Switch>
  );
};

export default Families;



// WEBPACK FOOTER //
// ./src/screens/family/Families.js